<div
  class="rc"
  [class.is-invalid]="!!error"
  role="group"
  [attr.aria-label]="position"
  [attr.aria-describedby]="error ? rowId + '-error' : null"
>
  <div class="rc__fields">
    <!-- Field -->
    <div class="bk-field rc__field">
      <label class="bk-field__label" [attr.for]="rowId + '-attr'">Field</label>
      <select
        class="bk-field__input"
        [id]="rowId + '-attr'"
        [attr.aria-invalid]="!!error && !segmentRule.attributeName"
        (change)="setAttribute($any($event.target).value)"
      >
        <option value="" disabled [selected]="!segmentRule.attributeName">Choose a field</option>
        @for (attribute of attributes; track attribute.label) {
          <option [value]="attribute.label" [selected]="attribute.label === segmentRule.attributeName">
            {{ attributeText[attribute.label] }}
          </option>
        }
      </select>
    </div>

    <!-- Comparison -->
    <div class="bk-field rc__field">
      <label class="bk-field__label" [attr.for]="rowId + '-op'">Comparison</label>
      <select
        class="bk-field__input"
        [id]="rowId + '-op'"
        [disabled]="!spec"
        (change)="setOperator($any($event.target).value)"
      >
        @if (!spec) {
          <option value="" selected>Choose a field first</option>
        }
        @for (operator of operators; track operator) {
          <option [value]="operator" [selected]="operator === segmentRule.rule">{{ operatorText[operator] }}</option>
        }
      </select>
    </div>

    <!-- Value -->
    <div class="bk-field rc__field rc__field--value">
      <label class="bk-field__label" [attr.for]="rowId + '-value'">
        {{ spec?.input === 'number' ? 'Age in years' : 'Value' }}
      </label>
      @switch (spec?.input) {
        @case ('gender') {
          <select
            class="bk-field__input"
            [id]="rowId + '-value'"
            [attr.aria-invalid]="!!error && !value"
            (change)="setValue($any($event.target).value)"
          >
            <option value="" disabled [selected]="!value">Choose</option>
            @for (option of genderOptions; track option.value) {
              <option [value]="option.value" [selected]="option.value === value.toUpperCase()">{{ option.label }}</option>
            }
          </select>
        }
        @case ('country') {
          <select
            class="bk-field__input"
            [id]="rowId + '-value'"
            [attr.aria-invalid]="!!error && !value"
            (change)="setValue($any($event.target).value)"
          >
            <option value="" disabled [selected]="!value">Choose a country</option>
            @for (country of countries; track country) {
              <option [value]="country" [selected]="country === value">{{ country }}</option>
            }
          </select>
        }
        @case ('date') {
          <input
            class="bk-field__input"
            type="date"
            [id]="rowId + '-value'"
            [value]="value"
            [attr.aria-invalid]="!!error && !value"
            (input)="setValue($any($event.target).value)"
          />
        }
        @case ('number') {
          <input
            class="bk-field__input"
            type="number"
            inputmode="numeric"
            min="0"
            max="130"
            step="1"
            placeholder="30"
            [id]="rowId + '-value'"
            [value]="value"
            [attr.aria-invalid]="!!error"
            (input)="setValue($any($event.target).value)"
          />
        }
        @default {
          <input
            class="bk-field__input"
            type="text"
            [id]="rowId + '-value'"
            [value]="value"
            [disabled]="!spec"
            [placeholder]="spec ? '' : 'Choose a field first'"
            [attr.aria-invalid]="!!error && !!spec && !value.trim()"
            (input)="setValue($any($event.target).value)"
          />
        }
      }
    </div>

    <div class="rc__remove">
      @if (canRemove) {
        <button
          type="button"
          class="bk-icon-btn"
          [attr.aria-label]="'Remove ' + position.toLowerCase()"
          matTooltip="Remove condition"
          (click)="removeSegment()"
        >
          <span class="bk-sym" aria-hidden="true">close</span>
        </button>
      }
    </div>
  </div>

  @if (error) {
    <p class="bk-field__error rc__error" [id]="rowId + '-error'">
      <span class="bk-sym" aria-hidden="true">error</span>
      <span>{{ error }}</span>
    </p>
  }
</div>
